import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-tab-team" }
const _hoisted_2 = { class: "as-active" }

import type { IMatch, IAnalysis } from "~src/interfaces";


const __default__ = {};

interface IProps {
  match: IMatch;
  data: IAnalysis;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TabRateScore',
  props: {
    match: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.match.home_team.name), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.match.away_team.name), 1)
    ]),
    _cache[0] || (_cache[0] = _createStaticVNode("<h2>tỷ lệ ghi/mất bàn thing</h2><div class=\"as-tab-team\"><div>30 trận gần nhất</div><div>50 trận gần nhất</div></div><div class=\"as-fx-comparision as-scoreComp\"><ul class=\"as-fx-data-left\"><li class=\"as-hScoredLi as-hScoredLi1\"><span class=\"as-fx-c-l home-bg\" style=\"width:16%;\"></span><span class=\"as-fx-c2 as-green\">16</span></li><li class=\"as-hScoredLi as-hScoredLi2\" style=\"display:none;\"><span class=\"as-fx-c-l as-home-bg\" style=\"width:16%;\"></span><span class=\"as-fx-c2 as-green\">16</span></li></ul><span class=\"as-fx-c-3\"><span>1~15</span></span><ul class=\"as-fx-data-right\"><li class=\"as-gScoredLi as-gScoredLi1\"><span class=\"as-fx-c-r as-away-bg\" style=\"width:15%;\"></span><span class=\"as-fx-c2\">15</span></li><li class=\"as-gScoredLi as-gScoredLi2\" style=\"display:none;\"><span class=\"as-fx-c-r as-away-bg\" style=\"width:15%;\"></span><span class=\"as-fx-c2\">15</span></li></ul></div>", 3))
  ], 64))
}
}

})